import { Reveal, SectionHeader } from "./Reveal";
import { competences, sujetsApprofondir } from "../../data/content";

export const Skills = () => (
  <section id="competences" className="relative py-24 md:py-32 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeader index="02" kicker="Compétences" title="Ce que je mobilise au" italic="quotidien." />
      <div className="grid md:grid-cols-2 gap-x-16 gap-y-12">
        {Object.entries(competences).map(([cat, list], i) => (
          <Reveal key={cat} delay={(i % 2) * 0.08}>
            <div>
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-8 bg-cyan/50" />
                <h3 className="font-display font-medium text-xl">{cat}</h3>
              </div>
              <div className="flex flex-wrap gap-2.5">
                {list.map((s, j) => (
                  <span
                    key={j}
                    className="text-sm border border-white/10 rounded-full px-4 py-2 text-[var(--text-2)] hover:text-white hover:border-cyan/50 transition-colors duration-300 cursor-default"
                    data-testid={`skill-${i}-${j}`}
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Sujets que je souhaite approfondir */}
      <Reveal delay={0.1}>
        <div className="mt-16 border-t border-white/5 pt-12" data-testid="sujets-approfondir">
          <div className="flex items-center gap-3 mb-3">
            <span className="h-px w-8 bg-cyan/50" />
            <h3 className="font-display font-medium text-xl">{sujetsApprofondir.titre}</h3>
          </div>
          <p className="text-sm text-[var(--text-2)] max-w-2xl mb-6">{sujetsApprofondir.intro}</p>
          <div className="flex flex-wrap gap-2.5">
            {sujetsApprofondir.items.map((s, j) => (
              <span
                key={j}
                className="text-sm border border-dashed border-white/15 rounded-full px-4 py-2 text-[var(--text-2)] cursor-default"
                data-testid={`sujet-${j}`}
              >
                {s}
              </span>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
